import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  OnDestroy,
  Renderer2,
  Signal,
  viewChild,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { SfChatService } from '../../../../shared/services/sf-chat.service';

@Component({
  selector: 'app-sf-chat-page',
  standalone: false,
  templateUrl: './sf-chat-page.component.html',
  styleUrl: './sf-chat-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SfChatPageComponent implements AfterViewInit, OnDestroy {
  private readonly sfChatService: SfChatService = inject(SfChatService);
  private readonly renderer: Renderer2 = inject(Renderer2);

  private readonly chatContainer: Signal<ElementRef<HTMLElement> | undefined> =
    viewChild<ElementRef<HTMLElement>>('chatContainer');

  public readonly chatReady$: Signal<boolean> = toSignal(
    this.sfChatService.waitForNextMessagingReady(),
    { initialValue: false }
  );

  ngAfterViewInit(): void {
    const container = this.chatContainer();
    if (container) {
      this.sfChatService.initEmbeddedMessaging(container.nativeElement).subscribe();
    }
  }

  ngOnDestroy(): void {
    const container = this.chatContainer();
    if (container) {
      this.renderer.removeChild(
        container.nativeElement.parentElement,
        container.nativeElement
      );
    }
  }
}
